// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"1908667a","54":"fe9194fa","187":"2c589deb","237":"054b0263","381":"9ec70397","425":"e5e51d4a","453":"53083fd9","494":"a16a605f","503":"e9dee79b","633":"bb9f691d","699":"1e59382d","706":"7c2cd3ea","806":"0928055c","888":"e0756ab6"}[chunkId] + ".chunk.js";
};